export default __webpack_public_path__ + "static/media/sms-logo.5f0da8ad.png";